// extracted by mini-css-extract-plugin
module.exports = {"selector":"styles_selector__sCKPD","selectorHolder":"styles_selectorHolder__wIU_e","selectorsPair":"styles_selectorsPair__T9xrs","line":"styles_line__uzWM0"};